import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';

import { TokenService } from './token.service';

// Http interceptor : intercept every http query and add Token to the header

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {

	constructor(public token: TokenService, private router: Router) {}

	intercept(req: HttpRequest < any > , next: HttpHandler): Observable < HttpEvent < any >> {

		const dupReq = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + this.token.getToken()) });

		return next.handle(dupReq)
			.catch(
				error => {

					if(error instanceof HttpErrorResponse){

						if(error.status == 401){

							this.token.logOut();
							this.router.navigate(['/pages/login']);
						}
					}

					return Observable.throw(error);
				});
	}
}


// WEBPACK FOOTER //
// ./src/app/authentication/http.interceptor.ts